import { render } from "./dropzone.vue?vue&type=template&id=ce387e9a&scoped=true"
import script from "./dropzone.vue?vue&type=script&lang=js"
export * from "./dropzone.vue?vue&type=script&lang=js"

import "./dropzone.vue?vue&type=style&index=0&id=ce387e9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce387e9a"]])

export default __exports__